/**
 * Mirrors `GET /api/mail/templates` (#377).
 *
 * **`name` is never translated and never mapped.** It is the sink's own word
 * for a mail, and the console's job is to show it and store it back unchanged —
 * a dictionary of mail names here would be the same leak `orders.ts` exists to
 * prevent one layer down. `label` and `description`, when the sink sends them,
 * are that sink's words for a person and are rendered unread.
 */

import { z } from 'zod'
import { apiClient } from './client.ts'

const templateSchema = z.object({
  name: z.string(),
  label: z.string().optional(),
  description: z.string().optional(),
})

const listSchema = z.object({
  /** `false` when this instance has no `[mail]` block — a normal state, not an error. */
  configured: z.boolean(),
  items: z.array(templateSchema),
})

export type MailTemplate = z.infer<typeof templateSchema>
export type MailTemplateList = z.infer<typeof listSchema>

export async function fetchMailTemplates(): Promise<MailTemplateList> {
  const { data } = await apiClient.get('/mail/templates')
  return listSchema.parse(data)
}
